import { SelectActivityTypeTag } from "./SelectActivityTypeTag.js";
import "react";
import { jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
//#region src/modules/Tags/shared/FormikSelectActivityTypeTag.tsx
var FormikSelectActivityTypeTag = (props) => {
	const form = useFormikContext();
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		children: ({ field, meta }) => {
			return /* @__PURE__ */ jsx(SelectActivityTypeTag, {
				...props,
				error: meta.touched && meta.error,
				valid: meta.touched && meta.value && !meta.error,
				onChangeOptions: (option) => {
					props.name && form.setFieldValue(props.name, option);
					if (props.onChangeOptions) props.onChangeOptions(option);
				},
				...field,
				onChange: null
			});
		}
	});
};
//#endregion
export { FormikSelectActivityTypeTag };

//# sourceMappingURL=FormikSelectActivityTypeTag.js.map